export default function helpNoteTitleIfPresent(getHelpNoteTooltipTitle, title) {
    if (typeof title !== 'string' || !title) {
        return undefined;
    }
    const resolved = getHelpNoteTooltipTitle(title);
    return resolved && resolved.includes('\n\n') ? resolved : undefined;
}
